<mat-dialog-actions class="password-dialog-header">
    <span class="password-dialog-title">
        Cambiar contraseña
    </span>
    <button class="password-dialog-close" mat-icon-button mat-dialog-close type="button" aria-label="Cerrar">
        <mat-icon>close</mat-icon>
    </button>
</mat-dialog-actions>
<mat-dialog-content class="content-password">
    <div class="password-content">
        <p class="password-subtitle">
            Actualiza tu contraseña para mantener segura tu cuenta.
        </p>
        <form class="password-form" method="post" [formGroup]="passwordForm" (ngSubmit)="changePassword()">
            <!-- Contraseña actual -->
            <div class="password-field">
                <label for="current-password">
                    CONTRASEÑA ACTUAL
                </label>
                <mat-form-field class="password-input" appearance="outline">
                    <input id="current-password" matInput formControlName="currentPassword" type="password"
                        placeholder="Contraseña actual">
                </mat-form-field>
                <mat-error *ngIf="currentPassword?.invalid && (currentPassword?.dirty || currentPassword?.touched)"
                    class="password-error">
                    {{ getErrorMessage('currentPassword') }}
                </mat-error>
            </div>
            <!-- Nueva contraseña -->
            <div class="password-field">
                <label for="new-password">
                    NUEVA CONTRASEÑA
                </label>
                <mat-form-field class="password-input" appearance="outline">
                    <input id="new-password" matInput formControlName="newPassword" type="password"
                        placeholder="Nueva contraseña">
                </mat-form-field>
                <mat-error *ngIf="newPassword?.invalid && (newPassword?.dirty || newPassword?.touched)"
                    class="password-error">
                    {{ getErrorMessage('newPassword') }}
                </mat-error>
            </div>
            <!-- Confirmar contraseña -->
            <div class="password-field">
                <label for="confirm-password">
                    CONFIRMAR NUEVA CONTRASEÑA
                </label>
                <mat-form-field class="password-input" appearance="outline">
                    <input id="confirm-password" matInput formControlName="confirmPassword" type="password"
                        placeholder="Confirmar nueva contraseña">
                </mat-form-field>
                <mat-error *ngIf="confirmPassword?.invalid && (confirmPassword?.dirty || confirmPassword?.touched)"
                    class="password-error">
                    {{ getErrorMessage('confirmPassword') }}
                </mat-error>
            </div>
            <!-- Guardar -->
            <button class="password-submit" mat-raised-button type="submit" [disabled]="!passwordForm.valid">
                Guardar
            </button>
        </form>
    </div>
</mat-dialog-content>